import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { breadcrumAction } from 'src/Redux/Action/breadcrumAction';
import { contentTypeAction } from 'src/Redux/Action/htmlAction';
import { bookChapterNameService } from 'src/Services/ApiHandlers/bookChapterNameService';

export default function LibraryNavigateBar({ chapterName, chapterType, id, chapterId }) {
  const [customChapterName, setCustomChapterName] = useState(chapterName);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.contentHTML.htmlContent);
  const breadCrumbState = useSelector((state) => state.breadCrumbDetal.breadCrumContent);
  const regExpState = useSelector((state) => state.regExpArrayDetail.regExpArray);
  const customState = useSelector((state) => state.customArrayDetail.customArray);
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(true);

  const { htmltype } = state;

  useEffect(() => {
    if (!id) {
      setLoading(false);
    } else {
      bookChapterNameService
        .getNames(id)
        .then((res) => {
          const names = res.data.names || [];
          setNames(names);
          const updatedChapterName = names.find((n) => n.content_id === chapterId)?.name || chapterName;
          setCustomChapterName(updatedChapterName);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, chapterId, chapterName]);

  const prevHandler = (urlObj) => {
    const myindex = regExpState.findIndex(function (item, i) {
      return item._id === urlObj.id;
    });

    const customIndex = customState.findIndex(function (item, i) {
      return item._id === urlObj.id;
    });

    if (myindex >= 0) {
      if (chapterType === 'author') {
        dispatch(
          contentTypeAction({
            renderType: chapterType,
            id: id,
            htmltype: htmltype,
            mainid: regExpState[myindex]._id,
            type: regExpState[myindex].type ? regExpState[myindex].type : 'chapter',
            routerType: 'HEADER',
            counterNum: myindex,
          })
        );
      }
      if (chapterType === 'instructor') {
        dispatch(
          contentTypeAction({
            renderType: chapterType,
            id: id,
            htmltype: htmltype,
            mainid: customState[customIndex]._id,
            type: customState[customIndex].type ? customState[customIndex].type : 'chapter',
            routerType: 'HEADER',
            counterNum: myindex,
          })
        );
      }
      dispatch(breadcrumAction([]));
      navigate(`${urlObj.url}`, { state: { id: urlObj.id } });
    } else if (customIndex >= 0) {
      if (chapterType === 'author') {
        dispatch(
          contentTypeAction({
            renderType: chapterType,
            id: id,
            htmltype: htmltype,
            mainid: customState[customIndex]._id,
            type: customState[customIndex].type ? customState[customIndex].type : 'chapter',
            routerType: 'HEADER',
            counterNum: customIndex,
          })
        );
      }
      if (chapterType === 'instructor') {
        dispatch(
          contentTypeAction({
            renderType: chapterType,
            id: id,
            htmltype: htmltype,
            mainid: customState[customIndex]._id,
            type: customState[customIndex].type ? customState[customIndex].type : 'chapter',
            routerType: 'HEADER',
            counterNum: customIndex,
          })
        );
      }
      dispatch(breadcrumAction([]));
      navigate(`${urlObj.url}`, { state: { id: urlObj.id } });
    } else {
      navigate(`${urlObj.url}`, { state: { id: urlObj.id } });
      dispatch(breadcrumAction([]));
    }
  };

  const namedBreadcrumb = breadCrumbState.map((b) => {
    const newBread = structuredClone(b);
    const hasName = names.find((n) => n.content_id === b.id);

    if (hasName) {
      newBread.title = hasName.name;
    }

    return newBread;
  });

  if (loading) {
    // Render nothing or a loader until data is fetched
    return null;
  }

  return (
    <div className="box text-center">
      <Typography variant="h1">{customChapterName}</Typography>
      <div className="breadCrumbsarea">
        <Breadcrumbs
          aria-label="breadcrumb"
          className="text-center justify-content-center"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          {namedBreadcrumb.length > 0 &&
            namedBreadcrumb.map((element, index) => {
              if (element.is_Home) {
                return (
                  <Link key={element.title} underline="hover" sx={{ display: 'flex' }} color="inherit" to={element.url}>
                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                    {element.title}
                  </Link>
                );
              } else if (!element.is_enable) {
                return (
                  <Typography sx={{ cursor: 'pointer' }} key={element.title} color="text.primary">
                    {element.title}
                  </Typography>
                );
              } else {
                return (
                  <Typography
                    sx={{ cursor: 'pointer' }}
                    key={element.title}
                    color="text.primary"
                    onClick={() => prevHandler(element)}
                  >
                    {element.title}
                  </Typography>
                );
              }
            })}
        </Breadcrumbs>
      </div>
    </div>
  );
}
